/**
 * This invItem Status options comes from the GenericEnumValue table on the wfms_inventorymanagement_dev database
 * You can also check the following link for  https://dev.azure.com/Olameter-Montreal/Mtl%20Dev%20department/_wiki/wikis/Mtl-Dev-department.wiki/2165/Work-Order-Statuses
 */

export enum InvStatusWebName {
  Field = 'StatusWeb',
  Title = 'Status',
}

export enum InvStatusWeb {
  Expected = 'Expected', // Meters that are Expected to arrive to the warehouse
  InStock = 'InStock', // Meters ready to be allocated to a technician
  AllocatedToTechnician = 'AllocatedToTechnician', // Meters Allocated to a technician
  Installed = 'Installed', // When a new meter is installed at a location
  RMA = 'RMA', // When we return a meter to the Utility
  Quarantined = 'Quarantined', // A do not use status
  UnderReview = 'UnderReview', // Meters under review by an external entity (Regulator, Utility, etc.) Is it required? Vs Quarantined
  NonConforming = 'NonConforming', // Meters that are not confirming
  Scrapped = 'Scrapped', // Legacy or New Meter sent for destruction
  Missing = 'Missing', // Location is unknown
}

export const InvStatusOptions = [
  {
    text: 'Expected',
    i18n: 'STATUS.EXPECTED',
    value: 'Expected',
    active: true,
  },
  {
    text: 'InStock',
    i18n: 'STATUS.IN_STOCK',
    value: 'InStock',
    active: false,
  },
  {
    text: 'Allocated To Technician',
    i18n: 'STATUS.ALLOCATED_TO_TECHNICIAN',
    value: 'AllocatedToTechnician',
    active: false,
  },
  {
    text: 'Installed',
    i18n: 'STATUS.INSTALLED',
    value: 'Installed',
    active: false,
  },
  {
    text: 'RMA',
    i18n: 'STATUS.RMA',
    value: 'RMA',
    active: false,
  },
  {
    text: 'Quarantined',
    i18n: 'STATUS.QUARANTINED',
    value: 'Quarantined',
    active: false,
  },
  {
    text: 'Under Review',
    i18n: 'STATUS.UNDER_REVIEW',
    value: 'UnderReview',
    active: false,
  },
  {
    text: 'Non-Conforming',
    i18n: 'STATUS.NON_CONFORMING',
    value: 'NonConforming',
    active: false,
  },
  {
    text: 'Scrapped',
    i18n: 'STATUS.SCRAPPED',
    value: 'Scrapped',
    active: false,
  },
  {
    text: 'Missing',
    i18n: 'STATUS.MISSING',
    value: 'Missing',
    active: false,
  },
];
